// extracted by mini-css-extract-plugin
module.exports = {"dashWrapper":"Dashboard_dashWrapper__3qciZ","dashInner":"Dashboard_dashInner__fiEvA"};